import React from 'react'
import styled from 'styled-components'
import { useNativeFormMutation } from '@mote/api'
import { isMobile } from '@mote/helpers/browser'
import { Block, Text } from '@mote/ui'
import { Emoji } from '../shared/components'
import { FeedbackForm } from './FeedbackForm'

export function Feedback({ cohort, event }) {
  const {
    mutate: sendToNativeForm,
    data,
    loading,
    error,
    fetched
  } = useNativeFormMutation()

  return (
    <Root margin={`${isMobile() ? 20 : 50}px 0 ${isMobile() ? 20 : 50}px 0`}>
      {!data && !error && (
        <>
          <Text
            fontSize={18}
            fontWeight={500}
            color={'#000000'}
            alignment='center'
          >
            Tell us what you think of the new look Mote experience
          </Text>

          <Block margin='30px 0 40px 0'>
            <FeedbackForm
              event={event}
              cohort={cohort}
              sendToNativeForm={sendToNativeForm}
              loading={loading}
            />
          </Block>
        </>
      )}

      {fetched && (
        <Block margin='30px 0 40px 0' align='center' justify='center'>
          <Text fontSize={15} fontWeight={400} color='black'>
            <Emoji>🙏</Emoji> Thanks for your feedback
          </Text>
        </Block>
      )}
    </Root>
  )
}

const Root = styled(Block)``
